<template>
  <CAlert show color="info" :fade="false" v-if="isAdminUser">
    <CRow>
      <CCol>
        <slot></slot>
      </CCol>
      <CCol xs="1">
        <CButton
          color="info"
          variant="ghost"
          class="m-1 p-0 pr-1 pl-1" 
          style="position: relative; top: -6px;"
          v-c-popover="{
            header: 'Account managers view',
            content: 'Only users with the ADMIN role can see this info box.'
          }"
        >
          <CIcon size="lg" name="cil-voice-over-record" />
        </CButton>
      </CCol>
    </CRow>
  </CAlert>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminAlert',
  computed: {
    ...mapGetters('auth', [
      'isAdminUser'
    ]),
  },
}
</script>